'use strict';

function ReferralPanel() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.contentId = '';
  this.extends = [_TrayModal, _ResponsiveLayout];
  this.contentfulEntryId = '6nu7tYthtuhh3y7Z5XDheE';
  this._analytics = new Analytics();
  this._history = new History();

  this.shareUrl = 'https://app.mogo.ca/go';
  this._FB_APP_ID = 2086740878273293; // Admin: https://www.facebook.com/peterwilson

  this.el = {};
  this._classes = {
    copyButton: 'js--copy-btn',
    copiedContent: 'js--copy-content',
    copyNotification: 'js--copy-notification',
    displayNotification: 'common-tray-copy-notification--active',
    copyOutput: 'js--copy-output',
    emailLink: 'js--share-email',
    facebookLink: 'js--share-facebook',
    twitterLink: 'js--share-twitter',
    shareLink: 'js--share-button',
    genericLayout: 'js--generic-layout-component'
  };

  this.init = function () {
    this.$node = $(this.node);
    this._super();

    this.el.$copyButton = $('.' + this._classes.copyButton);
    this.el.$copiedContent = $('.' + this._classes.copiedContent);
    this.el.$copyNotification = $('.' + this._classes.copyNotification);
    this.el.$copyOutput = $('.' + this._classes.copyOutput);
    this.el.$emailLink = $('.' + this._classes.emailLink);
    this.el.$facebookLink = $('.' + this._classes.facebookLink);
    this.el.$twitterLink = $('.' + this._classes.twitterLink);
    this.el.$shareButton = $('.' + this._classes.shareLink);
    this.el.genericLayout = $('.' + this._classes.genericLayout);
    this.el.linkTextToBlock = $('.' + this._classes.linkTextToBlock);

    // Contentful Content
    this.contentfulPromise = $.Deferred();
    this._loadContentful();
    // Call _onDataReady once the Promises have resolved
    $.when(this.contentfulPromise).then(this._onDataReady.bind(this));

    // Taken from CryptoFundEtransfer.js TODO - refactor out into reusuable function
    this._copyToClipboard();

    // Taken from ReferralShareBar.js  TODO - refactor out into reusuable function
    var requiredContentPath = this._getPageContentRefString();
    var requiredContent = this.presenter.getModelProperty(requiredContentPath);
    if (typeof requiredContent === 'undefined') {
      // wait for contentful content to load (from contentful or memory) before populating share content
      $.when(this.presenter._contentLoadedPromise).then(this._setupShareLinks.bind(this));
    } else {
      this._setupShareLinks();
    }
  };

  this.initAllReady = function () {
    this._super();
    this.analytics.forcePushEvent('virtual-page-view');
    this._setComputedVariables();
    this._setupShareLinks();
    this._bindEvents();
  };

  this._loadContentful = function () {
    this._contentful = new Contentful(_ContentfulConfiguration, $.extend({}, ContentfulSpaceParams, { verboseLevel: 1 }) // verboseLevel 1 required to have revision # returned.
    );

    this._contentful.getResource('ENTRY', { entry_id: this.contentfulEntryId }, this.contentfulPromise.resolve.bind(this));
  };

  this._onDataReady = function () {
    this.el.genericLayout.mogo().pushContentfulAnalyticsEvent();
  };

  this._bindEvents = function (e) {
    var _this2 = this;

    $('.js--referral-panel-close-btn').on('click', function (e) {
      _this2._analytics.forcePushEvent('generic-member-navigation', {
        memberNavigation: ['Referral-Navigation-Close-Navigation-Component']
      });

      var appState = _this2.presenter.models.appState.layout;
      if (appState.previous_uri) {
        _this2._history.goToUrl(appState.previous_uri);
      } else {
        _this2._history.goToUrl('/member/dashboard/home');
      }

      _this2._analytics.forcePushEvent('virtual-page-view', {
        Page: [window.location.origin + appState.previous_uri ? appState.previous_uri : '/member/dashboard/home']
      });
    });
  };

  // Taken from ReferralShareBar.js
  // TODO - refactor out into reusuable function
  this._setupShareLinks = function () {
    this.referralCode = this.presenter.getModelProperty('account.referral_code');
    this._setupEmailLink();
    this._setupFacebookLink();
    this._setupTwitterLink();
    this._setupShareButtons();
    // copy button analytics
    this.el.$copyButton.attr('data-analytics-id', 'Referral-Share on Paste-' + this.referralCode + '-null-Click');
  };

  this._setupEmailLink = function () {
    var contentModelRefString = this._getPageContentRefString();
    var nodeContentRefString = this.el.$emailLink.data();
    var ctaText = this.presenter.getModelProperty(contentModelRefString + '.' + nodeContentRefString.text);
    var emailSubject = this.presenter.getModelProperty(contentModelRefString + '.' + nodeContentRefString.emailSubject);
    var emailBody = this.presenter.getModelProperty(contentModelRefString + '.' + nodeContentRefString.emailBody);
    this.el.$emailLink.text(ctaText.content);
    this.el.$emailLink.attr('href', 'mailto:?subject=' + emailSubject.content + '&body=' + encodeURIComponent(emailBody.content) + ' ' + encodeURIComponent(this.shareUrl) + encodeURIComponent('?referral_code=') + this.referralCode + '%0D%0D');
    // analytics
    this.el.$emailLink.attr('data-analytics-id', 'Referral-Share on Email-' + this.referralCode + '-null-Click');
  };

  // Opens up share content (twitter / facebook) inside a new dialog
  // instead of current window
  this._setupShareButtons = function () {
    var _this = this;

    this.el.$shareButton.click(function (e) {
      e.preventDefault();
      _this.setActiveViewport(); // defined in _ResponsiveLayout

      // used to center new window in the screen
      var topPosition = window.top.outerHeight / 2 + window.top.screenY - 446 / 2;
      var leftPosition = window.top.outerWidth / 2 + window.top.screenX - 640 / 2;

      if (_this.largeViewport || _this.xlargeViewport) {
        this._activeShareWindow = window.open($(this).attr('href'), 'shareWindow', 'width=640, height=446, top=' + topPosition + ', left=' + leftPosition);
      } else {
        // mobile needs to open a new tab every time you click:
        this._activeShareWindow = window.open($(this).attr('href'), null);
      }
    });
  };

  this._setupFacebookLink = function () {
    var contentModelRefString = this._getPageContentRefString();
    var nodeContentRefString = this.el.$facebookLink.data();
    var ctaText = this.presenter.getModelProperty(contentModelRefString + '.' + nodeContentRefString.text);
    this.el.$facebookLink.text(ctaText.content);

    this.el.$facebookLink.attr('href', 'https://www.facebook.com/dialog/feed?app_id=' + this._FB_APP_ID + '&link=' + this.shareUrl + '?referral_code=' + this.referralCode);
    // analytics
    this.el.$facebookLink.attr('data-analytics-id', 'Referral-Share on Facebook-' + this.referralCode + '-null-Click');
  };

  this._setupTwitterLink = function () {
    var contentModelRefString = this._getPageContentRefString();
    var nodeContentRefString = this.el.$twitterLink.data();
    var ctaText = this.presenter.getModelProperty(contentModelRefString + '.' + nodeContentRefString.text);
    var subject = this.presenter.getModelProperty(contentModelRefString + '.' + nodeContentRefString.twitterSubject);
    this.el.$twitterLink.text(ctaText.content);
    this.el.$twitterLink.attr('href', '' + ('https://twitter.com/intent/tweet?' + '&original_referer=https://www.mogo.ca&ref_src=twsrc%5Etfw&related=MogoMoney&text=') + encodeURIComponent(subject.content) + '&tw_p=tweetbutton&url=' + this.shareUrl + '?referral_code=' + this.referralCode);
    // analytics
    this.el.$twitterLink.attr('data-analytics-id', 'Referral-Share on Twitter-' + this.referralCode + '-null-Click');
  };

  this._getPageContentRefString = function () {
    return 'content.pages.' + this.node.closest('[data-mogo-page]').dataset.mogoPage;
  };

  this._setComputedVariables = function () {
    var _this3 = this;

    this.referralCode = this.presenter.getModelProperty('account.referral_code');

    this.presenter.addComputedVariable('share_link', ['account.referral_code'], function () {
      return _this3.shareUrl + '?referral_code=' + _this3.referralCode;
    });

    this.presenter.addComputedVariable('valid_spend_eligibility', ['account.eligibility', 'account.referred_by_id', 'account.referrals'], function () {
      return _this3._hasValidSpendEligibility();
    });
  };

  // Copied from CryptoFundEtransfer.js
  // TODO - refactor out into reusuable function
  // Currently requires certains selectors to be avail
  // (_this._classes.displayNotification, _this.el.$copiedContent etc)
  this._copyToClipboard = function () {
    var _this = this;

    this.el.$copyButton.click(function () {
      var copiedText = $(this).find($(_this.el.$copiedContent)).text();

      var copyContent = document.createElement('input');
      document.body.appendChild(copyContent);
      copyContent.setAttribute('id', 'copyContent');

      var inputField = document.getElementById('copyContent');
      inputField.value = copiedText;

      var oldContentEditable = inputField.contentEditable;
      var oldReadOnly = inputField.readOnly;
      var range = document.createRange();

      if (navigator.userAgent.match(/ipad|ipod|iphone/i) === null) {
        copyContent.select(); // this command doesn't behave well on iOs devices
      } else {
        inputField.contenteditable = true;
        inputField.readonly = true;
        range.selectNodeContents(inputField);

        var s = window.getSelection();
        s.removeAllRanges();
        s.addRange(range);

        inputField.setSelectionRange(0, 999999); // A big number, to cover anything that could be inside the element.

        inputField.contentEditable = oldContentEditable;
        inputField.readOnly = oldReadOnly;
      }

      if (navigator.userAgent.match(/ipad|ipod|iphone/i) === null) {
        copyContent.select(); // this command doesn't behave well on iOs devices
      }

      document.execCommand('copy');
      document.body.removeChild(copyContent);

      _this.el.$copyOutput.text(copiedText);

      _this.el.$copyNotification.addClass(_this._classes.displayNotification);

      setTimeout(function () {
        _this.el.$copyNotification.removeClass(_this._classes.displayNotification);
      }, 5000);
    });
  };

  this._hasValidSpendEligibility = function () {
    var isEligibleForSpend = this.presenter.getModelProperty('account.eligibility.card');
    var joinedFromReferral = this.presenter.getModelProperty('account.referred_by_id'); // will return id if present
    var referralList = this.presenter.getModelProperty('account.referrals'); // returns array
    var hasSuccesfulReferral = referralList && referralList.find(function (referral) {
      return referral.kyc_decision === 'approved';
    }); // Sample output:  "referrals":[ { "kyc_decision":"approved", "member_id":13897 } ]

    // Conditions: (https://mogofintech.atlassian.net/browse/DV-1091)
    // - member IS eligible for Spend
    // - member does NOT have a successful referral
    // - member has NOT joined from a referral"
    return isEligibleForSpend && !joinedFromReferral && !hasSuccesfulReferral;
  };

  this.destroy = function () {
    this.presenter.removeComputedVariable('share_link');
    this.presenter.removeComputedVariable('valid_spend_eligibility');
  };
}